import _ from 'lodash';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
//import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import AuthUserContainer from '../../containers/AuthUser';
import EnhancedTableHead from '../../components/table/EnhancedTableHead';
import EquipmentContainer from '../../containers/Equipment';
import {isFiltered, sortTable, PureRecordRow} from '../../libs/tableUtilities';
import { getGlobalClasses } from '../../themes';
import FilterHeader from "../../components/table/FilterHeader";
import { getEquipmentDescriptionDisplay, EQUIPMENT_TYPE_IDS } from "../../libs/equipment";
import Note from "../../components/Note";

const statusNamesToClassName = {
	retired : {
		color : '#616161',
		fontWeight : 900,
	},
	retiredStillAssigned : {
		fontWeight : 900,
		color : '#FF500F',
	},
	active : {
		fontWeight : 900,
		color: '#4CAF50',
	},
};

const statusToDisplay = {
	retired : 'Retired',
	retiredStillAssigned : 'Retired Still Assigned',
	active : 'Active',
};

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		...statusNamesToClassName,
		table : {
			width: '100%',
			tableLayout: 'auto',
		},
	};
};

const columns = [{
	id: 'display',
	label: 'Display',
}, {
	id: 'status',
	label: 'Status'
}, {
	id: 'geoTabComment',
	label: 'GeoTab Comment',
}, {
	id: 'make',
	label: 'Make',
}, {
	id: 'model',
	label: 'Model',
}, {
	id: 'year',
	label: 'Year',
}, {
	id: 'geoTabVin',
	label: 'VIN',
}, {
	id: 'geoTabSerialNumber',
	label: 'Serial Number',
}, {
	id: 'dateCreated',
	label: 'Date Synced',
}, {
	id: 'actions',
	label : 'Edit',
	style : {textAlign : 'center'},
	isNotSortable : true,
}];




function processEquipments(equipments) {
	if (!equipments) { return; }

	return equipments.map((equipment) => {
		return {
			...equipment,
			status : equipment.status,
			statusDisplay : statusToDisplay[equipment.status],
			type:  getEquipmentDescriptionDisplay({ equipmentDescriptionId: equipment.equipmentDescriptionId }),
			dateCreatedFormatted: moment(equipment.dateCreated).format('MMM Do, YYYY'),
		};
	});
}

class Equipments extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'asc',
			orderBy: 'display',
			filter: '',
			formattedRows: processEquipments(props.equipments),
		};

		this.handleFilter = evt => this.setState({ filter: evt.target.value });
	}

	componentDidMount () {
		if (!this.props.equipments.length) {
			this.props.searchEquipments();
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.equipments !== this.props.equipments) {
			this.setState({
				formattedRows: processEquipments(this.props.equipments),
			});
		}
	}

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order : order, orderBy : orderBy });
	};

	handleEdit = (equipmentId) => {
		this.props.history.push(`/equipment/${EQUIPMENT_TYPE_IDS.truck}/update/${equipmentId}`);
	};

	handleFilter = (event) => {
		this.setState({ filter : event.target.value });
	};

	render() {
		const { classes } = this.props;
		const { filter, order, orderBy, formattedRows } = this.state;

		if (!formattedRows) {
			return (<div>Fetching trucks...</div>);
		}

		const filtered = formattedRows.filter((row) => {
			return !isFiltered({
				filter,
				row,
				fields: ['display', 'type', 'make', 'model', 'year']
			});
		});

		const rows = sortTable({
			rows : filtered,
			order,
			orderBy,
			handleValue: (orderBy === 'year') ? _.parseInt : undefined,
		});

		return (
			<Fragment>
				<FilterHeader
					value={filter}
					onChange={this.handleFilter}
					label="Trucks"
					//buttonText="Add Truck"
					//url={`/equipment/${EQUIPMENT_TYPE_IDS.truck}/add`}
					canMakeUpdates={true}
				/>

				<Paper className={classes.globalMainPaper}>

					<Note label={`All trucks are synced from GeoTabs and cannot be added here. 
							All new trucks must be made in GeoTabs and will be synced with Sphere every 10 minutes.`}
					/>

					<Table size='small' className={classes.table}>
						<EnhancedTableHead
							columns={columns}
							order={order}
							orderBy={orderBy}
							onRequestSort={this.handleSort}
						/>
						<TableBody>
							{rows.map(row => {
								/** @namespace row.model **/
								/** @namespace row.modelYear **/
								/** @namespace row.geoTabVin **/
								/** @namespace row.geoTabSerialNumber **/
								return (
									<PureRecordRow
										hover
										className={classes.row}
										key={row.equipmentId}
									>
										<TableCell>{row.display}</TableCell>
										<TableCell className={classes[row.status]}>{row.statusDisplay}</TableCell>
										<TableCell>{row.geoTabComment}</TableCell>
										<TableCell>{row.make}</TableCell>
										<TableCell>{row.model}</TableCell>
										<TableCell>{row.modelYear}</TableCell>
										<TableCell>{row.geoTabVin}</TableCell>
										<TableCell>{row.geoTabSerialNumber}</TableCell>
										<TableCell>{row.dateCreatedFormatted}</TableCell>
										<TableCell align={'center'} style={{whiteSpace:'nowrap'}}>
											<Button
												className={classes.button}
												onClick={() => this.handleEdit(row.equipmentId)}
											>
												Edit
											</Button>
										</TableCell>
									</PureRecordRow>
								);
							})}
						</TableBody>
					</Table>
				</Paper>
			</Fragment>
		);
	}
}

Equipments.propTypes = {
	classes: PropTypes.object.isRequired,

	searchEquipments: PropTypes.func.isRequired,
	equipments : PropTypes.array,

	permissions : PropTypes.array,
	order: PropTypes.string,
	orderBy: PropTypes.string,
	history : PropTypes.object,
	theme: PropTypes.object.isRequired,
	canMakeUpdates : PropTypes.bool,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	EquipmentContainer,
	AuthUserContainer,
])(Equipments);